import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api/api";
import "./VerifyEmail.css";

function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const verify = async () => {
      try {
        await api.get(`/auth/verify-email/${token}`);
        setStatus("success");
        setMessage("Your email has been verified.");
        setTimeout(() => navigate("/login"), 3500);
      } catch (err) {
        setStatus("error");
        setMessage(err.response?.data?.message || "This verification link is invalid or has expired.");
      }
    };

    verify();
  }, [token, navigate]);

  return (
    <div className="ve-page">
      <div className="ve-card">

        {status === "loading" && (
          <>
            <div className="ve-spinner" />
            <h2 className="ve-title">Verifying your email…</h2>
            <p className="ve-sub">Just a moment.</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="ve-icon ve-icon--success">✓</div>
            <h2 className="ve-title">Email verified!</h2>
            <p className="ve-sub">{message}</p>
            <p className="ve-redirect">Redirecting you to login in a moment…</p>
            <button
              className="ve-btn"
              onClick={() => navigate("/login")}
            >
              Go to Login →
            </button>
          </>
        )}

        {status === "error" && (
          <>
            <div className="ve-icon ve-icon--error">✕</div>
            <h2 className="ve-title">Verification failed</h2>
            <p className="ve-sub">{message}</p>
            <p className="ve-sub" style={{ marginTop: 0 }}>
              Try signing up again or contact{" "}
              <a href="mailto:learnliadev@gmail.com" className="ve-link">
                learnliadev@gmail.com
              </a>
            </p>
            <button
              className="ve-btn ve-btn--ghost"
              onClick={() => navigate("/signup")}
            >
              Back to Sign Up
            </button>
          </>
        )}

      </div>
    </div>
  );
}

export default VerifyEmail;